import { render } from "./WelcomeView.vue?vue&type=template&id=3f4a288b"
import script from "./WelcomeView.vue?vue&type=script&lang=js"
export * from "./WelcomeView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__